import axios_instance from "../repository";
const path = "/v2/organization";
/**
 * @typedef {Object} Organization
 */
export default {
  get() {
    return new Promise((resolve, reject) => {
      axios_instance
        .get(`${path}`)
        .then(data => {
          return resolve(data.data.object);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  async update({
    id,
    name = undefined,
    icon = undefined,
    favicon = undefined
  }) {
    return await axios_instance
      .put(path, { name, icon, id, favicon })
      .then(data => {
        return Promise.resolve();
      });
  }
};
